
(function(){
  function init(){
    var nav = document.querySelector('.header-section .header-menu__list--main') || document.querySelector('.header-menu__list--main');
    var root = document.getElementById('sjwmm-root');
    if(!nav || !root) return;
    var KEYS = ['jewelry','lab','shape','occasion','style','colored'];
    var panels = {};
    KEYS.forEach(function(k){ panels[k] = root.querySelector('.sjwmm-panel[data-mm="'+k+'"]'); });
    var scrim = root.querySelector('.sjwmm-scrim');
    var headerEl = document.querySelector('.header-section .header') || document.querySelector('.header-section');
    var current = null, currentTrigger = null, openTimer = null, closeTimer = null, bound = false;
    var restoringFocus = false;
    var OPEN_DELAY = 200, CLOSE_DELAY = 280;
    var ENTER_EVENT = window.PointerEvent ? 'pointerenter' : 'mouseenter';
    var LEAVE_EVENT = window.PointerEvent ? 'pointerleave' : 'mouseleave';

    function pointerType(e){
      if(e && e.pointerType) return e.pointerType;
      return window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches ? 'mouse' : 'touch';
    }

    function keyFromHandle(h){
      h = (h||'').toLowerCase();
      if(h.indexOf('gemstone') > -1 || h.indexOf('colored') > -1) return 'colored';
      if(h.indexOf('jewelry-by-shape') > -1 || h.indexOf('by-shape') > -1 || h === 'shape') return 'shape';
      if(h.indexOf('lab') > -1 || h.indexOf('loose') > -1) return 'lab';
      if(h.indexOf('occasion') > -1 || h.indexOf('gift') > -1) return 'occasion';
      if(h.indexOf('style') > -1) return 'style';
      if(h.indexOf('jewelry') > -1) return 'jewelry';
      return null;
    }
    function keyFromText(t){
      t = (t||'').trim().toLowerCase();
      if(t.indexOf('gemstone') > -1 || t.indexOf('colored') > -1) return 'colored';
      if(t.indexOf('by shape') > -1 || t === 'shape') return 'shape';
      if(t.indexOf('lab') > -1 || t.indexOf('loose') > -1) return 'lab';
      if(t.indexOf('occasion') > -1 || t.indexOf('gift') > -1) return 'occasion';
      if(t.indexOf('style') > -1) return 'style';
      if(t.indexOf('jewelry') > -1) return 'jewelry';
      return null;
    }
    function setTop(){
      var b = headerEl ? headerEl.getBoundingClientRect().bottom : 120;
      root.style.setProperty('--sjwmm-top', Math.max(0, Math.round(b)) + 'px');
    }
    function hydratePanel(k){
      var panel = panels[k];
      if(!panel) return null;
      var template = panel.querySelector('template[data-sjwmm-panel-template]');
      if(template){
        panel.appendChild(template.content);
        template.remove();
      }
      return panel;
    }
    function open(k, trigger){
      if(!hydratePanel(k) || window.innerWidth < 990) return;
      clearTimeout(openTimer); openTimer = null;
      clearTimeout(closeTimer); setTop();
      KEYS.forEach(function(panelKey){
        var panel = panels[panelKey];
        if(!panel) return;
        var active = panelKey === k;
        panel.classList.toggle('on', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        panel.inert = !active;
      });
      if(currentTrigger && currentTrigger !== trigger) currentTrigger.setAttribute('aria-expanded','false');
      root.classList.add('open'); root.setAttribute('aria-hidden','false'); current = k;
      currentTrigger = trigger || currentTrigger;
      if(currentTrigger) currentTrigger.setAttribute('aria-expanded','true');
    }
    function cancelOpen(){ clearTimeout(openTimer); openTimer = null; }
    function scheduleOpen(k, trigger, pointerType){
      if(pointerType === 'touch' || window.innerWidth < 990) return;
      hydratePanel(k);
      cancelOpen();
      clearTimeout(closeTimer);
      openTimer = setTimeout(function(){ open(k, trigger); }, OPEN_DELAY);
    }
    function focusFirst(k){
      var panel = hydratePanel(k);
      var first = panel && panel.querySelector('a[href],button:not([disabled])');
      if(first) window.requestAnimationFrame(function(){
        if(current !== k) return;
        first.focus();
        if(document.activeElement !== first){
          window.setTimeout(function(){
            if(current === k && document.activeElement !== first) first.focus();
          }, 320);
        }
      });
    }
    function close(restoreFocus){
      cancelOpen();
      clearTimeout(closeTimer); closeTimer = null;
      KEYS.forEach(function(panelKey){
        var panel = panels[panelKey];
        if(!panel) return;
        panel.classList.remove('on');
        panel.setAttribute('aria-hidden','true');
        panel.inert = true;
      });
      root.classList.remove('open'); root.setAttribute('aria-hidden','true');
      if(currentTrigger) currentTrigger.setAttribute('aria-expanded','false');
      if(restoreFocus && currentTrigger){
        restoringFocus = true;
        currentTrigger.focus();
        restoringFocus = false;
      }
      current = null; currentTrigger = null;
    }
    function scheduleClose(){ cancelOpen(); clearTimeout(closeTimer); closeTimer = setTimeout(function(){ close(false); }, CLOSE_DELAY); }

    function bind(){
      // top-level dropdown triggers carry data-target="headerDesktopMenu:{handle}-{i}"
      var trigs = nav.querySelectorAll('.js-header-dropdown-menu-toggler, [data-sjw-mega-trigger]');
      [].forEach.call(trigs, function(tr){
        if(tr.__sjwmm) return; tr.__sjwmm = true;
        var li = tr.closest('.header-menu__item-wrapper') || tr.closest('li') || tr;
        var dt = tr.getAttribute('data-sjw-mega-trigger') || tr.getAttribute('data-target') || tr.getAttribute('aria-controls') || '';
        var handle = dt.split(':').pop() || '';
        var k = keyFromHandle(handle) || keyFromText(tr.textContent);
        if(!k) return;
        var panelId = 'sjwmm-panel-' + k;
        panels[k].id = panelId;
        tr.removeAttribute('aria-haspopup');
        tr.setAttribute('aria-controls',panelId);
        tr.setAttribute('aria-expanded','false');
        li.addEventListener(ENTER_EVENT, function(e){ scheduleOpen(k,tr,pointerType(e)); });
        li.addEventListener(LEAVE_EVENT, function(){ cancelOpen(); if(!li.contains(document.activeElement) && current) scheduleClose(); });
        tr.addEventListener('focus', function(){ if(!restoringFocus) open(k,tr); });
        tr.addEventListener('keydown', function(e){
          if(e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' '){
            e.preventDefault();
            open(k,tr);
            focusFirst(k);
          }
        });
        bound = true;
      });
      // items with NO dropdown toggler should close the menu on hover
      var allTop = nav.children;
      [].forEach.call(allTop, function(li){
        if(li.__sjwmmClose) return; li.__sjwmmClose = true;
        if(li.querySelector && li.querySelector('.js-header-dropdown-menu-toggler, [data-sjw-mega-trigger]')) return;
        li.addEventListener(ENTER_EVENT, function(){ cancelOpen(); if(current) scheduleClose(); });
      });
    }

    KEYS.forEach(function(k){
      var p = panels[k]; if(!p) return;
      p.addEventListener(ENTER_EVENT, function(e){ if(pointerType(e) === 'touch') return; cancelOpen(); clearTimeout(closeTimer); });
      p.addEventListener(LEAVE_EVENT, function(e){ if(pointerType(e) !== 'touch') scheduleClose(); });
    });
    scrim.addEventListener('click', function(){ close(false); });
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Escape' && e.keyCode !== 27) return;
      if(current) close(true); else cancelOpen();
    });
    document.addEventListener('focusin', function(e){
      if(nav.contains(e.target) || (current && panels[current] && panels[current].contains(e.target))){ cancelOpen(); clearTimeout(closeTimer); return; }
      cancelOpen();
      if(current) close(false);
    });
    window.addEventListener('scroll', function(){ if(current) setTop(); }, {passive:true});
    window.addEventListener('resize', function(){ if(current) setTop(); if(window.innerWidth < 990) close(); });

    bind();
    // re-bind if the theme rebuilds the nav
    if(window.MutationObserver){
      var mo = new MutationObserver(function(){ bind(); });
      mo.observe(nav, {childList:true, subtree:true});
    }
    if(bound){ document.documentElement.classList.add('sjwmm-ready'); }
    else {
      // last-resort: bind by top-level text if no togglers were found
      [].forEach.call(nav.children, function(li){
        var k = keyFromText((li.querySelector('[data-text]') && li.querySelector('[data-text]').getAttribute('data-text')) || li.textContent);
        if(!k) return;
        var fallbackTrigger = li.querySelector('a,button');
        li.addEventListener(ENTER_EVENT, function(e){ scheduleOpen(k,fallbackTrigger,pointerType(e)); });
        li.addEventListener(LEAVE_EVENT, function(){ cancelOpen(); if(current) scheduleClose(); });
        if(fallbackTrigger){
          fallbackTrigger.addEventListener('focus', function(){ if(!restoringFocus) open(k,fallbackTrigger); });
          fallbackTrigger.addEventListener('keydown', function(e){
            if(e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' '){
              e.preventDefault(); open(k,fallbackTrigger); focusFirst(k);
            }
          });
        }
        bound = true;
      });
      if(bound) document.documentElement.classList.add('sjwmm-ready');
    }
  }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
